import { createClient } from '@supabase/supabase-js'

/**
 * The Supabase client. Used ONLY for authentication -- sending magic links and
 * holding the session. Every piece of application data goes through the FastAPI
 * backend via the generated API hooks; this app never queries Postgres directly.
 *
 * This module deliberately imports nothing from the rest of the app. That is
 * what lets the fetch mutator read the session directly without creating an
 * import cycle with the generated hooks.
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

// Vite substitutes these at BUILD time. If the build ran without them, they are
// `undefined` here and supabase-js would fail with something cryptic deep in its
// internals. Fail immediately with a message that says what to actually do.
if (!supabaseUrl || !publishableKey) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set at BUILD time. ' +
      'Locally: copy frontend/.env.example to frontend/.env and fill it in. ' +
      'In Docker: pass them as build ARGs, not runtime env vars.',
  )
}

export const supabase = createClient(supabaseUrl, publishableKey, {
  auth: {
    persistSession: true, // survive a page reload (stored in localStorage)
    autoRefreshToken: true, // refresh the access token before it expires
    detectSessionInUrl: true, // consume the token the magic link puts in the URL
  },
})
